export interface ObjectStr {
  [key: string]: string
}

export const DATE_FORMAT = 'DD-MM-YYYY'
export const DATE_FORMAT_2 = 'YYYY-MM-DD'
export const TIME_FORMAT = 'HH:ss'
export const DATETIME_FORMAT = 'HH:ss DD-MM-YYYY'
export const PAGING = { page: 1, pageSize: 25 }

export const TRANSPORTATION_METHOD_LABEL: ObjectStr = {
  OFFICIAL_QUOTA: 'Chính ngạch',
  UNOFFICIAL_QUOTA: 'Tiểu ngạch',
  E_COMMERCE: 'Thương mại điện tử',
}
export const TRANSPORTATION_METHOD_VALUE: { [key: string]: string } = {
  OFFICIAL_QUOTA: 'OFFICIAL_QUOTA',
  UNOFFICIAL_QUOTA: 'UNOFFICIAL_QUOTA',
  E_COMMERCE: 'E_COMMERCE',
}

export const TRANSPORTATION_METHODS = [
  {
    label: 'Chính ngạch',
    value: TRANSPORTATION_METHOD_VALUE.OFFICIAL_QUOTA,
  },
  {
    label: 'Tiểu ngạch',
    value: TRANSPORTATION_METHOD_VALUE.UNOFFICIAL_QUOTA,
  },
  {
    label: 'Thương mại điện tử',
    value: TRANSPORTATION_METHOD_VALUE.E_COMMERCE,
  },
]

export const ORDER_SERVICES_LABEL: ObjectStr = {
  tallyingService: 'Dịch vụ kiểm đếm',
  packagingService: 'Dịch vụ kiểm đếm',
  impactResistanceService: 'Dịch vụ kiểm đếm',
  exportImportService: 'Dịch vụ xuất/nhập khẩu',
}

export const CONFIG_PRICE_ITEM: any = {
  from: 0,
  to: undefined,
  price: undefined,
}

export const SHIPMENT_STATUSES = {
  IN_FROM_WAREHOUSE: 'IN_FROM_WAREHOUSE',
  TURN_AROUND: 'TURN_AROUND',
  LOADING: 'LOADING',
  IN_CONT: 'IN_CONT',
  DEPARTED: 'DEPARTED',
  ARRIVED: 'ARRIVED',
  RETURNED: 'RETURNED',
  IN_TO_WAREHOUSE: 'IN_TO_WAREHOUSE',
  ON_DELIVERY: 'ON_DELIVERY',
  DELIVERED: 'DELIVERED',
  COMPLETED: 'COMPLETED',
  LOST: 'LOST',
}

export type ShipmentStatus = typeof SHIPMENT_STATUSES[keyof typeof SHIPMENT_STATUSES]

export const SHIPMENT_STATUSES_LABEL: any = {
  IN_FROM_WAREHOUSE: 'Trong kho nguồn',
  TURN_AROUND: 'Hàng quay đầu',
  LOADING: 'Đang xếp container',
  IN_CONT: 'Trong container',
  DEPARTED: 'Khởi hành',
  ARRIVED: 'Cập cảng',
  RETURNED: 'Về kho',
  IN_TO_WAREHOUSE: 'Trong kho đích',
  LOST: 'Thất lạc',
  DELIVERED: 'Đã giao hàng',
  ON_DELIVERY: 'Đang giao hàng',
  COMPLETED: 'Hoàn thành',
}

export const PACKAGE_STATUSES: any = {
  INCOMING: {
    value: 'incoming',
    label: 'Chờ về kho',
  },
  IN_SOURCE_WAREHOUSE: {
    value: 'in_source_warehouse',
    label: 'Trong kho (nguồn)',
  },
  IN_SLOT: {
    value: 'in_slot',
    label: 'Xếp xe',
  },
  IN_CONT: {
    value: 'in_cont',
    label: 'Trong container',
  },
  EXPORT_GATE: {
    value: 'export_gate',
    label: 'Cửa khẩu xuất',
  },
  IMPORT_GATE: {
    value: 'import_gate',
    label: 'Cửa khẩu nhập',
  },
  OUT_CONT: {
    value: 'out_cont',
    label: 'Hạ kiện',
  },
  LOST: {
    value: 'lost',
    label: 'Thất lạc',
  },
  STORAGE: {
    value: 'storage',
    label: 'Lưu kho',
  },
  IN_DESTINATION_WAREHOUSE: {
    value: 'in_destination_warehouse',
    label: 'Trong kho (đích)',
  },
  WAITING_FOR_DELIVERY: {
    value: 'waiting_for_delivery',
    label: 'Chờ trả hàng',
  },
  DELIVERED: {
    value: 'delivered',
    label: 'Đã giao',
  },
  COMPLETED: {
    value: 'completed',
    label: 'Hoàn thành',
  },
  RISK: {
    value: 'risk',
    label: 'Rủi ro',
  },
}

export const STATUS_EDITABLE = [
  'incoming',
  'in_source_warehouse',
  'in_slot',
  'in_cont',
  'out_cont',
  'export_gate',
  'import_gate',
  'lost',
  'storage',
  'in_destination_warehouse',
]

export const EDITABLE = [
  'incoming',
  'in_source_warehouse',
  'in_slot',
]

export const STATUS_CREATE_EXPORT_NOTE = [
  'in_destination_warehouse',
  'waiting_for_delivery',
  'delivered',
  'completed',
  'risk',
]

export const CURRENCIES_SYMBOL = {
  VND: '₫',
  CNY: 'CN¥',
  USD: '$',
}

export const WAREHOUSE = {
  HN: {
    label: 'Kho Hà Nội',
    value: 'HN',
    code: 'HN',
    national: 'VN',
  },
  HCM: {
    label: 'Kho Hồ Chí Minh',
    value: 'HCM',
    code: 'HCM',
    national: 'VN',
  },
  QC: {
    label: 'Kho Quảng Châu',
    value: 'QC',
    code: 'QC',
    national: 'CN',
  },
  BT: {
    label: 'Kho Bằng Tường',
    value: 'BT',
    code: 'BT',
    national: 'CN',
  },
}
export const LIST_WAREHOUSES = [WAREHOUSE.HN, WAREHOUSE.HCM, WAREHOUSE.QC, WAREHOUSE.BT]
export const CONTAINER_STATUSES = {
  NEW: 'NEW',
  LOADING: 'LOADING',
  CLOSED: 'CLOSED',
  DEPARTED: 'DEPARTED',
  ARRIVED: 'ARRIVED',
  RETURNED: 'RETURNED',
  UNLOADING: 'UNLOADING',
  DONE: 'DONE',
  DELETED: 'DELETED',
}
export const CONTAINER_STATUSES_LABEL: any = {
  NEW: 'Mới tạo',
  LOADING: 'Đang bốc hàng',
  CLOSED: 'Đã đóng cont',
  DEPARTED: 'Rời cảng',
  ARRIVED: 'Cập cảng',
  RETURNED: 'Đã về kho',
  UNLOADING: 'Đang dỡ hàng',
  DONE: 'Hoàn thành',
  DELETED: 'Xóa',
}

export const CONTAINER_TO_SHIPMENT_STATUSES = {
  RETURNED: 'IN_TO_WAREHOUSE',
  ARRIVED: 'ARRIVED',
  DEPARTED: 'DEPARTED',
  LOADING: 'LOADING',
}

export enum Role {
  SuperAdmin = 'super_admin',
  Admin = 'admin',
  Manager = 'manager',
  StandardUser = 'standard_user',
}

export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  MANAGER: 'manager',
  STANDARD_USER: 'standard_user',
}

export function normalizeRole(role: string | undefined): string | undefined {
  if (role == null || role === '') return undefined
  const r = role.toLowerCase().replace(/\s/g, '')
  if (r === 'superadmin') return USER_ROLES.SUPER_ADMIN
  if (r === 'standarduser') return USER_ROLES.STANDARD_USER
  return r
}

export const USER_ROLES_LABEL = {
  super_admin: 'Super admin',
  admin: 'Admin',
  manager: 'Quản lý',
  standard_user: 'Nhân viên',
  customer: 'Khách hàng',
}
export const ROLES_OPTIONS = [
  {
    id: USER_ROLES.STANDARD_USER,
    name: 'Nhân viên',
  },
  {
    id: USER_ROLES.MANAGER,
    name: 'Người quản lý',
  },
]
export const ROLES_OPTIONS_ADMIN = [
  ...ROLES_OPTIONS,
  {
    id: USER_ROLES.ADMIN,
    name: 'Admin',
  },
]
export const ROLES_OPTIONS_FULL = [
  ...ROLES_OPTIONS_ADMIN,
  {
    id: USER_ROLES.SUPER_ADMIN,
    name: 'Super admin',
  },
]

export const DEPARTMENT_CODE = {
  SALES: 'SALES',
  CUSTOMER_SERVICE: 'CUSTOMER_SERVICE',
  DOCUMENTATION: 'DOCUMENTATION',
  WAREHOUSE: 'WAREHOUSE',
  ACCOUNTING: 'ACCOUNTING',
  MANAGEMENT: 'MANAGEMENT',
}

export const DEPARTMENTS = {
  SALES: 'Kinh doanh',
  CUSTOMER_SERVICE: 'CSKH',
  DOCUMENTATION: 'Chứng từ',
  WAREHOUSE: 'Kho',
  ACCOUNTING: 'Kế toán',
  MANAGEMENT: 'Ban Giám đốc',
}

export const POSITIONS = {
  HO: 'HO',
  DIRECTOR: 'Giám Đốc',
  MANAGER: 'Quản lí',
  STAFF: 'Nhân viên',
  INTERN: 'Thực tập sinh',
}

export const DEPARTMENT_OPTIONS = [
  { id: 'SALES', name: 'Kinh doanh' },
  { id: 'CUSTOMER_SERVICE', name: 'CSKH' },
  { id: 'DOCUMENTATION', name: 'Chứng từ' },
  { id: 'WAREHOUSE', name: 'Kho' },
  { id: 'ACCOUNTING', name: 'Kế toán' },
  { id: 'MANAGEMENT', name: 'Ban Giám đốc' },
]

export const POSITION_OPTIONS = [
  { id: 'STAFF', name: 'Nhân viên' },
  { id: 'INTERN', name: 'Thực tập sinh' },
  { id: 'HO', name: 'HO' },
  { id: 'MANAGER', name: 'Quản lí' },
  { id: 'DIRECTOR', name: 'Giám Đốc' },
]
